__webpack_require__.p = "https://documents.kyu.ac.ug/";